// /mnt/mantenimientos/frontend/src/components/ClientesTab.jsx
import React, { useEffect, useMemo, useState, useCallback } from "react";
import ImportarClientes from "./ImportarClientes";
import NuevoClienteModal from "./NuevoClienteModal";
import VistaPreviaImportacion from "./VistaPreviaImportacion";
import GestionClientes from "./GestionTab";

import {
  getClientes as getClientesAPI,
  getOrdenadoresPorCliente as getOrdenadoresPorClienteAPI,
  crearCliente as crearClienteAPI,
  crearOrdenador as crearOrdenadorAPI,
  actualizarOrdenador as actualizarOrdenadorAPI,
  actualizarOrdenadorSpecs as actualizarOrdenadorSpecsAPI,
  eliminarOrdenador as eliminarOrdenadorAPI,
  eliminarCliente as eliminarClienteAPI,
  actualizarCliente,
} from "../api";

import "./clientesModal.css";
import "./clientesSplitView.css";
import { isAdmin } from "../utils/auth";
import ModuleHeader from "./ui/ModuleHeader";
import EntityIndexItem from "./ui/EntityIndexItem";

function normalizeSpecsFromObj(obj) {
  const hostname = String(obj?.hostname || "").trim() || null;
  const ip = String(obj?.ip || "").trim() || null;
  const so = String(obj?.so || "").trim() || null;
  const usuario = String(obj?.usuario || "").trim() || null;

  const serial = String(obj?.serial || "").trim() || null;
  const cpu = String(obj?.cpu || "").trim() || null;

  const ram_gb = obj?.ram_gb === "" || obj?.ram_gb === undefined || obj?.ram_gb === null ? null : Number(obj.ram_gb);
  const disco_gb =
    obj?.disco_gb === "" || obj?.disco_gb === undefined || obj?.disco_gb === null ? null : Number(obj.disco_gb);

  const ramOk = Number.isFinite(ram_gb) ? Math.trunc(ram_gb) : null;
  const discoOk = Number.isFinite(disco_gb) ? Math.trunc(disco_gb) : null;

  const ssd = !!obj?.ssd;

  const hasSpecs = !!(hostname || ip || so || usuario || serial || cpu || ramOk || discoOk || ssd);

  return {
    hasSpecs,
    payload: {
      hostname,
      ip,
      so,
      usuario,
      serial,
      cpu,
      ram_gb: ramOk,
      disco_gb: discoOk,
      ssd,
    },
  };
}

export default function ClientesTab({
  clientes: clientesProp,
  setClientes: setClientesProp,
  getOrdenadoresPorCliente: getOrdenadoresPorClienteProp,
}) {
  const admin = isAdmin();
  // ✅ fallback interno por si no vienen props o vienen vacías
  const [clientesLocal, setClientesLocal] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [errorList, setErrorList] = useState("");

  const clientes = Array.isArray(clientesProp) ? clientesProp : clientesLocal;
  const setClientes =
    typeof setClientesProp === "function" ? setClientesProp : setClientesLocal;

  const getOrdenadoresPorCliente =
    typeof getOrdenadoresPorClienteProp === "function"
      ? getOrdenadoresPorClienteProp
      : getOrdenadoresPorClienteAPI;

  // ✅ autoload si no llegan clientes por props (o llegan vacíos)
  useEffect(() => {
    let cancelled = false;

    if (Array.isArray(clientesProp) && clientesProp.length > 0) return;

    (async () => {
      try {
        setLoadingList(true);
        setErrorList("");
        const res = await getClientesAPI();
        const list = Array.isArray(res?.data) ? res.data : [];
        if (!cancelled) setClientes(list);
      } catch (e) {
        console.error("[ClientesTab] Error getClientes:", e);
        if (!cancelled) {
          setClientes([]);
          setErrorList("No se pudo cargar la lista de clientes.");
        }
      } finally {
        if (!cancelled) setLoadingList(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [clientesProp, setClientes]);

  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [clienteEdit, setClienteEdit] = useState({
    nombre: "",
    telefono: "",
    observaciones: "",
    codigo_cliente: "",
    email: "",
    direccion: "",
    es_cliente_mantenimiento: true,
  });

  const [ordenadores, setOrdenadores] = useState([]);

  // ✅ nuevoOrdenador incluye TODOS los campos que GestionTab edita/crea
  const [nuevoOrdenador, setNuevoOrdenador] = useState({
    descripcion: "",
    hostname: "",
    ip: "",
    so: "",
    usuario: "",
    teamviewer_id: "",
    info_adicional: "",
  });

  const [mostrarFormOrdenador, setMostrarFormOrdenador] = useState(false);
  const [subTab, setSubTab] = useState("detalles");
  const [mostrarModalCrear, setMostrarModalCrear] = useState(false);

  const [nuevoCliente, setNuevoCliente] = useState({
    nombre: "",
    telefono: "",
    observaciones: "",
    codigo_cliente: "",
    email: "",
    direccion: "",
    es_cliente_mantenimiento: true,
  });

  const [datosImportacion, setDatosImportacion] = useState([]);
  const [mostrarVistaPrevia, setMostrarVistaPrevia] = useState(false);
  const [busqueda, setBusqueda] = useState("");

  // ✅ refresco centralizado (evita “parece que no guarda”)
  const refrescarOrdenadores = useCallback(async () => {
    const id = clienteSeleccionado?.id;
    if (!id) return;
    const res = await getOrdenadoresPorCliente(id);
    setOrdenadores(res?.data || []);
  }, [clienteSeleccionado?.id, getOrdenadoresPorCliente]);

  // ✅ “Cerrar” ahora significa: deseleccionar + limpiar panel
  const cerrarGestion = () => {
    setClienteSeleccionado(null);
    setOrdenadores([]);
    setClienteEdit({
      nombre: "",
      telefono: "",
      observaciones: "",
      codigo_cliente: "",
      email: "",
      direccion: "",
      es_cliente_mantenimiento: true,
    });
    setSubTab("detalles");
    setNuevoOrdenador({
      descripcion: "",
      hostname: "",
      ip: "",
      so: "",
      usuario: "",
      teamviewer_id: "",
      info_adicional: "",
    });
    setMostrarFormOrdenador(false);
  };

  const crearCliente = async (clienteData) => {
    try {
      const res = await crearClienteAPI(clienteData);
      setClientes((prev) => [...(Array.isArray(prev) ? prev : []), res.data]);
      setMostrarModalCrear(false);
      setNuevoCliente({
        nombre: "",
        telefono: "",
        observaciones: "",
        codigo_cliente: "",
        email: "",
    direccion: "",
        es_cliente_mantenimiento: true,
      });
    } catch (err) {
      console.error("Error creando cliente:", err);
      alert("No se pudo crear el cliente.");
    }
  };

  const importarClientes = (listaClientes) => {
    setDatosImportacion(listaClientes);
    setMostrarVistaPrevia(true);
  };

  const confirmarImportacion = async () => {
    for (const cliente of datosImportacion) {
      try {
        const res = await crearClienteAPI(cliente);
        const clienteCreado = res.data;

        for (const pc of cliente.ordenadores || []) {
          // 1) base
          const pcRes = await crearOrdenadorAPI({
            cliente_id: clienteCreado.id,
            descripcion: String(pc.descripcion || "").trim(),
            info_adicional: String(pc.info_adicional || "").trim(),
            teamviewer_id: String(pc.teamviewer_id || "").trim() || null,
          });

          const creado = pcRes.data;

          // 2) specs si hay
          const { hasSpecs, payload } = normalizeSpecsFromObj(pc);
          if (hasSpecs && creado?.id) {
            try {
              await actualizarOrdenadorSpecsAPI(creado.id, payload);
            } catch (e) {
              console.warn(
                "[Import] No se pudieron guardar specs:",
                e?.response?.data || e.message
              );
            }
          }
        }

        setClientes((prev) => [
          ...(Array.isArray(prev) ? prev : []),
          clienteCreado,
        ]);
      } catch (err) {
        console.error("Error importando cliente:", err);
      }
    }

    alert("✅ Importación completada.");
    setMostrarVistaPrevia(false);
    setDatosImportacion([]);
  };

  const seleccionarCliente = async (id) => {
    try {
      const cliente = (Array.isArray(clientes) ? clientes : []).find(
        (c) => c.id === id
      );
      if (!cliente) return alert("Cliente no encontrado en la lista.");

      setClienteSeleccionado(cliente);
      setClienteEdit({ ...cliente });

      const res = await getOrdenadoresPorCliente(id);
      setOrdenadores(res.data || []);

      setSubTab("detalles");
      setMostrarFormOrdenador(false);
      setNuevoOrdenador({
        descripcion: "",
        hostname: "",
        ip: "",
        so: "",
        usuario: "",
        teamviewer_id: "",
        info_adicional: "",
      });
    } catch (err) {
      console.error("Error al cargar ordenadores:", err);
      alert("No se pudo cargar el cliente.");
    }
  };

  const guardarCliente = async () => {
    try {
      await actualizarCliente(clienteSeleccionado.id, clienteEdit);

      setClientes((prev) =>
        (Array.isArray(prev) ? prev : []).map((c) =>
          c.id === clienteSeleccionado.id ? { ...c, ...clienteEdit } : c
        )
      );

      setClienteSeleccionado((prev) =>
        prev ? { ...prev, ...clienteEdit } : prev
      );

      alert("✅ Cliente actualizado correctamente");
    } catch (err) {
      console.error("Error actualizando cliente:", err);
      alert("No se pudo actualizar el cliente.");
    }
  };

  const eliminarCliente = async () => {
    if (!window.confirm("¿Eliminar este cliente y todos sus datos relacionados?"))
      return;
    try {
      const id = clienteSeleccionado.id;
      await eliminarClienteAPI(id);
      setClientes((prev) =>
        (Array.isArray(prev) ? prev : []).filter((c) => c.id !== id)
      );
      cerrarGestion();
    } catch (err) {
      console.error("Error al eliminar cliente:", err);
      alert("No se pudo eliminar el cliente.");
    }
  };

  /**
   * ✅ Crear equipo en 2 fases:
   * 1) POST base
   * 2) PUT specs (si hay)
   * 3) refrescar lista
   *
   * IMPORTANTE: si falla specs, avisamos claramente (ya no “parece que no guarda”).
   */
  const crearOrdenador = async () => {
    const descripcion = String(nuevoOrdenador?.descripcion || "").trim();
    if (!descripcion) {
      alert("La descripción no puede estar vacía.");
      return;
    }
    if (!clienteSeleccionado?.id) {
      alert("No hay cliente seleccionado.");
      return;
    }

    try {
      // 1) crear base
      const res = await crearOrdenadorAPI({
        cliente_id: clienteSeleccionado.id,
        descripcion,
        info_adicional: String(nuevoOrdenador?.info_adicional || "").trim(),
        teamviewer_id: String(nuevoOrdenador?.teamviewer_id || "").trim() || null,
      });

      const creado = res.data;

      // 2) specs si hay algo
      const { hasSpecs, payload } = normalizeSpecsFromObj(nuevoOrdenador);

      if (hasSpecs && creado?.id) {
        try {
          // Debug temporal (puedes quitarlo luego)
          console.log("[crearOrdenador] specs payload =>", creado.id, payload);

          await actualizarOrdenadorSpecsAPI(creado.id, payload);
        } catch (e) {
          console.error(
            "[crearOrdenador] ERROR guardando specs:",
            e?.response?.data || e.message
          );
          alert(
            "⚠️ El equipo se creó, pero falló el guardado de specs (hostname/ip/so/usuario). Revisa consola."
          );
        }
      }

      // 3) refresca lista
      await refrescarOrdenadores();

      setNuevoOrdenador({
        descripcion: "",
        hostname: "",
        ip: "",
        so: "",
        usuario: "",
        teamviewer_id: "",
        info_adicional: "",
      });
      setMostrarFormOrdenador(false);
    } catch (err) {
      console.error("Error creando ordenador:", err);
      alert("No se pudo crear el ordenador.");
    }
  };

  const eliminarOrdenador = async (id) => {
    if (!window.confirm("¿Eliminar este ordenador?")) return;
    try {
      await eliminarOrdenadorAPI(id);
      setOrdenadores((prev) => prev.filter((o) => o.id !== id));
    } catch (err) {
      console.error("Error eliminando ordenador:", err);
      alert("No se pudo eliminar el ordenador.");
    }
  };

  const guardarOrdenador = async (ordenadorId, patch) => {
    try {
      await actualizarOrdenadorAPI(ordenadorId, patch);
      setOrdenadores((prev) =>
        prev.map((o) => (o.id === ordenadorId ? { ...o, ...patch } : o))
      );
      alert("✅ Ordenador actualizado");
    } catch (err) {
      console.error("Error actualizando ordenador:", err);
      alert("No se pudo actualizar el ordenador.");
    }
  };

  const clientesFiltrados = useMemo(() => {
    const b = busqueda.trim().toLowerCase();
    const list = Array.isArray(clientes) ? clientes : [];
    if (!b) return list;

    return list.filter((c) => {
      const nombre = String(c?.nombre || "").toLowerCase();
      const codigo = String(c?.codigo_cliente ?? "");
      return nombre.includes(b) || codigo.includes(busqueda.trim());
    });
  }, [clientes, busqueda]);

  const selectedId = clienteSeleccionado?.id ?? null;

  return (
    <div className="cl-page">
      <ModuleHeader eyebrow="Administración" title="Clientes" description="Gestiona datos de cliente, equipos y credenciales desde un único lugar." />
    <div className="clSplit">
      {/* LEFT: índice */}
      <aside className="card clientesIndex" aria-label="Índice de clientes">
        <header className="clientesIndexHead">
          <div>
            <strong>Clientes</strong>
            <span>{clientesFiltrados.length} visibles</span>
          </div>
          <div className="clientesIndexActions">
            <button className="button primary small" type="button" onClick={() => setMostrarModalCrear(true)}>＋ Nuevo</button>
            <ImportarClientes onImportar={importarClientes} />
          </div>
        </header>
        <input className="input clientesIndexSearch" type="text" placeholder="Buscar por nombre o código…" value={busqueda} onChange={(e) => setBusqueda(e.target.value)} />
        {loadingList ? <div className="clientesIndexMessage">Cargando clientes…</div> : null}
        {errorList ? <div className="clientesIndexMessage is-error">{errorList}</div> : null}
        <div className="clientesIndexResults">
          {!loadingList && clientesFiltrados.length === 0 ? <div className="mp-empty-state"><strong>No hay clientes con este filtro</strong><span>Prueba otra búsqueda o crea un cliente.</span></div> : [...clientesFiltrados].sort((a, b) => String(a?.nombre || "").localeCompare(String(b?.nombre || ""))).map((c) => <EntityIndexItem key={c.id} selected={c.id === selectedId} onClick={() => seleccionarCliente(c.id)} title={c.nombre || "Cliente sin nombre"} subtitle={c.telefono ? "Teléfono: " + c.telefono : c.email || "ID: " + c.id} status={{ label: c.codigo_cliente || "Sin código", tone: "neutral" }} tags={c.email ? [c.email] : []} />)}
        </div>
      </aside>

      {/* RIGHT: detalle */}
      <div className="clSplitRight">
        <div className="card clDetailCard">
          {!clienteSeleccionado ? (
            <div className="clEmptyPanel">
              <div style={{ fontWeight: 700, marginBottom: 6 }}>
                Selecciona un cliente
              </div>
              <div style={{ opacity: 0.8 }}>
                El panel de la derecha mostrará detalles, equipos y credenciales.
              </div>
            </div>
          ) : (
            <>
              <div className="clDetailHead">
                <div className="clDetailHeadLeft">
                  <div className="clDetailTitleRow">
                    <h2 className="clDetailTitle">
                      {clienteSeleccionado?.nombre || "Cliente"}
                    </h2>
                    <span className="clDetailChip">
                      {clienteSeleccionado?.codigo_cliente || "—"}
                    </span>
                  </div>
                  <div className="clDetailSub">
                    Gestión: datos, equipos y credenciales
                  </div>
                </div>

                <div className="clDetailActions">
                  <button className="button secondary small" type="button" onClick={cerrarGestion}>
                    ← Volver
                  </button>
                </div>
              </div>

              <GestionClientes
                subTab={subTab}
                setSubTab={setSubTab}
                clienteEdit={clienteEdit}
                setClienteEdit={setClienteEdit}
                guardarCliente={guardarCliente}
                eliminarCliente={eliminarCliente}
                ordenadores={ordenadores}
                nuevoOrdenador={nuevoOrdenador}
                setNuevoOrdenador={setNuevoOrdenador}
                crearOrdenador={crearOrdenador}
                eliminarOrdenador={admin ? eliminarOrdenador : null}
                guardarOrdenador={guardarOrdenador}
                mostrarFormOrdenador={mostrarFormOrdenador}
                setMostrarFormOrdenador={setMostrarFormOrdenador}
                clienteId={clienteSeleccionado?.id}
                clienteNombre={clienteSeleccionado?.nombre}
                refrescarOrdenadores={refrescarOrdenadores}
              />
            </>
          )}
        </div>
      </div>

      {/* MODAL NUEVO CLIENTE */}
      <NuevoClienteModal
        visible={mostrarModalCrear}
        nuevoCliente={nuevoCliente}
        setNuevoCliente={setNuevoCliente}
        onCrear={() => crearCliente(nuevoCliente)}
        onCancelar={() => setMostrarModalCrear(false)}
      />

      {/* VISTA PREVIA IMPORT */}
      <VistaPreviaImportacion
        visible={mostrarVistaPrevia}
        datos={datosImportacion}
        onConfirmar={confirmarImportacion}
        onCancelar={() => setMostrarVistaPrevia(false)}
      />
    </div>
    </div>
  );
}
